module.exports = __webpack_public_path__ + "static/media/Ap.1e1eaf61.png";